import { Injectable } from '@angular/core';
import { SafariObject } from '@safarilaw-webapp/shared/common-objects-models';
import { ApiDataAdapter, NoHiddenProps } from '@safarilaw-webapp/shared/crud';
import { ValueItemModel, ValueModel } from '../../_squirrel-api-models.generated';
import { SquirrelValue } from '../models/app/squirrel-value';

@Injectable({
  providedIn: 'root'
})
export class SquirrelValueAdapter extends ApiDataAdapter<SquirrelValue> {
  toUpdateModel(o: SquirrelValue): Required<ValueItemModel> {
    // NOTE:  we really should guard here to make sure we don't have > 1 item in the array!
    return {
      isolationLevel: o.values[0].isolationLevel,
      value: o.values[0].value
    };
  }
  fromGetModel(o: ValueModel): Required<NoHiddenProps<SquirrelValue>> {
    return {
      id: SafariObject.id(o.app, o.key),
      values: o.values as [{ isolationLevel: number; value: string }]
    };
  }
  fromListModel(o: ValueModel): Required<NoHiddenProps<SquirrelValue>> {
    return {
      id: SafariObject.id(o.app, o.key),
      values: o.values as [{ isolationLevel: number; value: string }]
    };
  }
}
